import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | admin | denied
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true,
        });
        if (response.status === 200 && response.data.role === 'admin') {
          setUser(response.data);
          setStatus('admin');
        } else {
          setStatus('denied');
          navigate('/dashboard', { replace: true });
        }
      } catch {
        setStatus('denied');
        navigate('/', { replace: true });
      }
    };
    checkAdmin();
  }, [navigate]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center gradient-mesh">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verificando permisos...</p>
        </div>
      </div>
    );
  }

  if (status !== 'admin') return null;

  return React.cloneElement(children, { user });
};

export default AdminRoute;
